import React, { useState } from 'react';
import { TopBanner } from './components/TopBanner';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { Contact } from './pages/Contact';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <Home data-id="element-0" />;
      case 'about':
        return <About data-id="element-1" />;
      case 'services':
        return <Services data-id="element-2" />;
      case 'contact':
        return <Contact data-id="element-3" />;
      default:
        return <Home data-id="element-4" />;
    }
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 flex flex-col" data-id="element-5">
      <TopBanner data-id="element-6" />
      <Header currentPage={currentPage} onNavigate={setCurrentPage} data-id="element-7" />
      <main className="flex-grow" data-id="element-8">{renderPage()}</main>
      <Footer data-id="element-9" />
    </div>;
}